module.exports = __webpack_public_path__ + "static/media/girl-11.db007233.svg";